import { render, staticRenderFns } from "./SafeActions.vue?vue&type=template&id=1fa5672c&scoped=true"
import script from "./SafeActions.vue?vue&type=script&lang=js"
export * from "./SafeActions.vue?vue&type=script&lang=js"
import style0 from "./SafeActions.vue?vue&type=style&index=0&id=1fa5672c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa5672c",
  null
  
)

export default component.exports